module.exports = __webpack_public_path__ + "img/70800.f39fc401.jpg";